import React, { useState } from 'react';
import 'date-fns';
import {
  Card,
  CardContent,
  Grid,
  FormControl,
  Box,
  TextField,
  InputLabel,
  MenuItem,
  FormGroup,
  Select,
  Avatar,
  IconButton,
  Switch,
  FormControlLabel,
} from '@material-ui/core';

import { LinkPrimaryButton, PrimaryButton } from '.';
import { DropzoneArea } from 'material-ui-dropzone';
import CreatableSelect from 'react-select/creatable';
import MultiSelect from 'react-select';
import './FormCustom.scss';
import { Link, useLocation } from 'react-router-dom';
import PrimaryOutlinedButton from './PrimaryOutlinedButton';
import { useForm } from 'react-hook-form';

export const FormCustom = ({
  list = [],
  formClass = '',
  formVariant = 'outlined',
  clients = [],
  skills = [],
  locations = [],
  userTypes = [],
  userRoles = [],
  isView = false,
  isEdit = false,
  formSubmit = () => {},
  buttonSection = {
    isRequired: true,
    list: [{ viewText: 'Edit', editText: 'Update', createText: 'Save' }],
  },
} = {}) => {
  const [client, setClient] = React.useState([]);
  const [files, setFiles] = useState([]);
  const [inputList, setInputList] = useState([]);
  const currentLocation = useLocation();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  // { interviewStatus: '', comment: '' }

  // Handle change for select with checkbox
  const handleChange = (event) => {
    setClient(event.target.value);
  };

  // Handle change for multiselect create
  let handleChangeMultiSelectCreate = (newValue, actionMeta) => {
    console.group('Value Changed');
    console.log(newValue);
    console.log(`action: ${actionMeta.action}`);
    console.groupEnd();
  };

  // Drag and drop handle change
  let dragDropHandleChange = (filesArray) => {
    setFiles(filesArray);
    console.log('files', files);
  };

  // add more
  const handleAddClick = () => {
    setInputList([...inputList, { interviewStatus: '', comment: '' }]);
  };

  // handle change of added input
  const handleInputChange = (e, index) => {
    const { name, value } = e.target;
    const list = [...inputList];
    list[index][name] = value;
    setInputList(list);
  };

  // remove
  const handleRemoveClick = (index) => {
    const list = [...inputList];
    console.log(list);
    list.splice(index, 1);
    setInputList(list);
  };

  const errorMessage = (itemVal = {}) => (
    <>
      {itemVal?.errors?.map((error, index) => (
        <span key={index}>
          {errors[itemVal?.name]?.type === error?.type && (
            <span className="error">{error?.message}</span>
          )}
        </span>
      ))}
    </>
  );

  return (
    <form autoComplete="off" onSubmit={handleSubmit(formSubmit)}>
      <Card className={`${formClass}`} variant={formVariant}>
        <CardContent>
          {/* Form elements grouped based on the data */}
          {list?.map((group, index) => (
            <div key={index}>
              {group?.key && (
                <FormGroup className={group?.groupClass}>
                  {/*  Company avatar */}
                  <div className={group?.avatar?.formControlClass}>
                    {group?.avatar && (
                      <Avatar variant={group?.avatar?.variant} className={group.avatar.className}>
                        {group?.avatar?.logo}
                      </Avatar>
                    )}

                    <Box pb={2}>
                      <h5 className={group?.groupLabelClass}> {group?.groupLabel} </h5>
                    </Box>
                  </div>

                  <Grid container spacing={1}>
                    {group?.inputs?.map((itemVal, groupIndex) => (
                      <Grid
                        item
                        xs={itemVal?.xs || 12}
                        sm={itemVal?.sm || 12}
                        md={itemVal?.md || 6}
                        lg={itemVal?.lg || 4}
                        xl={itemVal?.xl || 4}
                        key={groupIndex}
                      >
                        {/* Type: Text */}
                        {itemVal?.type === 'text' && (
                          <Box className={itemVal?.formElementClass}>
                            <label className={itemVal?.labelClass}> {itemVal?.label} </label>
                            <Box pb={1}>
                              <FormControl className={itemVal?.formControlClass}>
                                <TextField
                                  className={itemVal?.fieldClass}
                                  label={itemVal?.placeholder}
                                  variant={itemVal?.variant}
                                  margin={itemVal?.margin}
                                  name={itemVal?.name}
                                  value={itemVal?.defaultValue}
                                  inputProps={{
                                    readOnly: itemVal?.readOnly,
                                    maxLength: itemVal?.max,
                                  }}
                                  {...register(itemVal?.name, {
                                    required: itemVal?.isRequired,
                                    pattern: itemVal?.pattern,
                                    min: itemVal?.min,
                                  })}
                                  disabled={isView && true}
                                />
                              </FormControl>
                              {errorMessage(itemVal)}
                            </Box>
                          </Box>
                        )}

                        {/* Type: Multiselect with create  */}
                        {itemVal?.type === 'multiSelectCreate' && (
                          <Box className={itemVal?.formElementClass}>
                            <label className={itemVal?.labelClass}> {itemVal?.label} </label>
                            <Box pt={1} pb={1}>
                              <FormControl className={itemVal?.formControlClass}>
                                <CreatableSelect
                                  isMulti
                                  onChange={handleChangeMultiSelectCreate}
                                  className={itemVal?.fieldClass}
                                  options={skills}
                                  placeholder={itemVal?.placeholder}
                                  isDisabled={isView ? true : ''}
                                />
                              </FormControl>
                              {errorMessage(itemVal)}
                            </Box>
                          </Box>
                        )}

                        {/* Type: Multiselect */}
                        {itemVal?.type === 'multiselect' && (
                          <Box className={itemVal?.formElementClass}>
                            <label className={itemVal?.labelClass}> {itemVal?.label} </label>
                            <Box pt={1} pb={1}>
                              <FormControl className={itemVal?.formControlClass}>
                                <MultiSelect
                                  isMulti
                                  options={clients}
                                  className={itemVal?.fieldClass}
                                  placeholder={itemVal?.placeholder}
                                  isDisabled={isView && true}
                                />
                              </FormControl>
                              {errorMessage(itemVal)}
                            </Box>
                          </Box>
                        )}

                        {/* Type: Select with no create */}
                        {itemVal?.type === 'select' && (
                          <Box className={itemVal?.formElementClass}>
                            <label className={itemVal?.labelClass}> {itemVal?.label} </label>
                            <Box pt={1} pb={1}>
                              <FormControl
                                className={itemVal?.formControlClass}
                                variant={itemVal?.variant}
                                size={itemVal?.size}
                              >
                                <InputLabel>{itemVal?.label}</InputLabel>
                                <Select
                                  className={itemVal?.fieldClass}
                                  placeholder={itemVal?.placeholder}
                                  label={itemVal?.label}
                                  inputProps={{
                                    disabled: isView && true,
                                  }}
                                  {...register(itemVal?.name, {
                                    required: itemVal?.isRequired,
                                    pattern: itemVal?.pattern,
                                    min: itemVal?.min,
                                  })}
                                >
                                  <MenuItem value="">Choose {itemVal?.placeholder}</MenuItem>

                                  {itemVal?.options &&
                                    itemVal?.options.map((type, userTypesIndex) => (
                                      <MenuItem key={userTypesIndex} value={type?.value}>
                                        {type?.label}
                                      </MenuItem>
                                    ))}
                                </Select>
                              </FormControl>
                              {errorMessage(itemVal)}
                            </Box>
                          </Box>
                        )}

                        {/* Type: Avatar  */}
                        {itemVal?.type === 'avatar' && (
                          <Box className={itemVal?.formElementClass}>
                            <label className={itemVal?.labelClass}> {itemVal?.label} </label>
                            <Box pt={1} pb={1}>
                              <FormControl
                                className={itemVal?.formControlClass}
                                variant={itemVal?.variant}
                                size={itemVal?.size}
                              >
                                <Avatar variant={itemVal?.variant}>{itemVal?.logo}</Avatar>
                              </FormControl>
                            </Box>
                          </Box>
                        )}

                        {/* Type: Single select with create  */}
                        {itemVal?.type === 'singleSelectCreate' && (
                          <Box className={itemVal?.formElementClass}>
                            <label className={itemVal?.labelClass}> {itemVal?.label} </label>
                            <Box pt={1} pb={1}>
                              <FormControl className={itemVal?.formControlClass}>
                                <CreatableSelect
                                  isClearable
                                  onChange={handleChangeMultiSelectCreate}
                                  className={itemVal?.fieldClass}
                                  options={skills}
                                  placeholder={itemVal?.placeholder}
                                  inputProps={{
                                    disabled: isView && true,
                                  }}
                                />
                              </FormControl>
                            </Box>
                          </Box>
                        )}

                        {/* Type: Link */}
                        {itemVal?.type === 'link' && (
                          <Box className={itemVal?.formElementClass}>
                            <label className={itemVal?.labelClass}> {itemVal?.label} </label>
                            <Box pt={1} pb={1}>
                              <FormControl className={itemVal?.formControlClass}>
                                <Link to={itemVal?.url} target={itemVal?.target}>
                                  {itemVal?.placeholder}
                                </Link>
                              </FormControl>
                            </Box>
                          </Box>
                        )}

                        {/* Type: File Dropzone */}
                        {!isView && itemVal?.type === 'dropzone' && (
                          <Box className={itemVal?.formElementClass}>
                            <label className={itemVal?.labelClass}> {itemVal?.label} </label>
                            <Box pt={1} pb={1}>
                              <FormControl className={itemVal?.formControlClass}>
                                <DropzoneArea
                                  onChange={dragDropHandleChange}
                                  inputProps={{
                                    disabled: isView && true,
                                  }}
                                />
                              </FormControl>
                            </Box>
                          </Box>
                        )}
                        {/* End File Dropzone */}

                        {/* Type: File Upload */}
                        {itemVal?.type === 'file' && (
                          <Box
                            className={itemVal?.formElementClass}
                            display="flex"
                            alignItems="center"
                            justifyContent="space-between"
                          >
                            <Box pt={1} pb={1}>
                              <FormControl className={itemVal?.formControlClass}>
                                <input
                                  accept={itemVal?.accept}
                                  className={itemVal.fieldClass}
                                  id={itemVal?.id}
                                  type={itemVal?.type}
                                  disabled={isView && true}
                                />

                                <label htmlFor={itemVal?.id}>
                                  <IconButton component="span">
                                    <itemVal.icon />
                                  </IconButton>
                                </label>
                              </FormControl>
                            </Box>

                            {/* Upload button */}
                            {!isView && (
                              <Box
                                display="flex"
                                flexDirection="column"
                                justifyContent="center"
                                alignItems="end"
                              >
                                <PrimaryButton text="Change" />
                                <PrimaryOutlinedButton text="Remove" />
                              </Box>
                            )}
                          </Box>
                        )}
                        {/* End: File Upload */}

                        {/* Type: Toggle Switch */}
                        {itemVal?.type === 'toggle' && (
                          <Box className={itemVal?.formElementClass}>
                            <FormControl className={itemVal?.formControlClass}>
                              <FormControlLabel
                                value={itemVal?.label}
                                control={
                                  <Switch color="secondary" disabled={isView ? true : false} />
                                }
                                label={itemVal?.label}
                                labelPlacement={itemVal.labelPlacement}
                              />
                            </FormControl>
                            {errorMessage(itemVal)}
                          </Box>
                        )}
                        {/* End: Toggle Switch  */}

                        {/* Type: Password  */}
                        {itemVal?.type === 'password' && (
                          <Box className={itemVal?.formElementClass}>
                            <label className={itemVal?.labelClass}> {itemVal?.label} </label>
                            <Box pb={1}>
                              <FormControl className={itemVal?.formControlClass}>
                                <TextField
                                  className={itemVal?.fieldClass}
                                  label={itemVal?.placeholder}
                                  variant={itemVal?.variant}
                                  margin={itemVal?.margin}
                                  name={itemVal?.name}
                                  type={itemVal?.type}
                                />
                              </FormControl>
                              {errorMessage(itemVal)}
                            </Box>
                          </Box>
                        )}
                        {/* End: Password */}

                        {/* Type: Button  */}
                        {itemVal?.type === 'button' && (
                          <Box className={itemVal?.formElementClass}>
                            <PrimaryButton text={itemVal?.label} />
                          </Box>
                        )}
                        {/* End: Button */}

                        {/* Type: Link Button */}
                        {itemVal?.type === 'linkButton' &&
                          ((itemVal?.key === 'add_button' && (
                            <Box className={itemVal?.formElementClass} mt={3}>
                              <label className={itemVal?.labelClass}> </label>
                              <Box pt={2}>
                                <FormControl className={itemVal?.formControlClass}>
                                  <Link
                                    className={itemVal?.fieldClass}
                                    to="#"
                                    onClick
                                    onClick={handleAddClick}
                                  >
                                    {<itemVal.icon />}
                                  </Link>
                                </FormControl>
                              </Box>
                            </Box>
                          )) || (
                            <>
                              {inputList.length > 0 && inputList.length !== 1 && (
                                <Box className={itemVal?.formElementClass} mt={3}>
                                  <label className={itemVal?.labelClass}> </label>
                                  <Box pt={2}>
                                    <FormControl className={itemVal?.formControlClass}>
                                      <Link
                                        className={itemVal?.fieldClass}
                                        to="#"
                                        onClick
                                        onClick={handleAddClick}
                                      >
                                        {<itemVal.icon />}
                                      </Link>
                                    </FormControl>
                                  </Box>
                                </Box>
                              )}
                            </>
                          ))}
                      </Grid>
                    ))}
                  </Grid>
                </FormGroup>
              )}

              {group?.key === 'interview' && (
                <>
                  {inputList.map((list, inputListIndex) => (
                    <Grid container spacing={1} key={inputListIndex}>
                      <Grid item xs={12} lg={4}>
                        <TextField
                          variant={'outlined'}
                          placeholder={'Interview Status'}
                          size={'small'}
                          value={list.interviewStatus}
                          name={'interviewStatus'}
                          onChange={(e) => handleInputChange(e, inputListIndex)}
                        />
                      </Grid>

                      <Grid item xs={12} lg={4}>
                        <TextField
                          variant={'outlined'}
                          placeholder={'Comment'}
                          size={'small'}
                          value={list.comment}
                          name={'comment'}
                          multiline
                          onChange={(e) => handleInputChange(e, inputListIndex)}
                        />
                      </Grid>

                      <Grid item xs={12} lg={4}>
                        {inputList.length > 0 && inputList.length !== 1 && (
                          <Link onClick={() => handleRemoveClick(inputListIndex)}> Remove </Link>
                        )}
                        {inputList.length - 1 === inputListIndex && (
                          <Link
                            style={{ marginLeft: '20px' }}
                            className={'link-button'}
                            onClick
                            onClick={handleAddClick}
                          >
                            Add
                          </Link>
                        )}
                      </Grid>
                    </Grid>
                  ))}
                </>
              )}
            </div>
          ))}

          {buttonSection.isRequired &&
            buttonSection?.list?.map((button, buttonIndex) => (
              <Grid container spacing={1} key={buttonIndex}>
                <Grid item xs={12}>
                  <Box mt={2}>
                    <PrimaryButton
                      text={isView ? button.viewText : isEdit ? button.editText : button.createText}
                    />
                  </Box>
                </Grid>
              </Grid>
            ))}
        </CardContent>
      </Card>
    </form>
  );
};
